import React, { useEffect, useState } from "react";
import useReactRouter from "use-react-router";
import {
  faAddressBook,
  faInfoCircle,
  faPodcast,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToasts } from "react-toast-notifications";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import { useLazyQuery, useMutation } from "@apollo/client";
import { SHOP } from "../../../graphql/shop/queryShop";
import { GET_SHOP_COMMISION_INFLUENCER } from "../../../graphql/influencer/query";
import Switch from "react-switch";
import { Form, Spinner } from "react-bootstrap";
import {
  UPDATE_SHOP,
  UPDATE_SHOP_SETTING_SERVICE,
} from "../../../graphql/shop/mutation";

function SettingSPage() {
  const { addToast } = useToasts();
  const { history } = useReactRouter();
  const { height, width } = useWindowDimensions();
  const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

  const [shopDetail, setShopDetail] = useState({});

  const settings = [
    {
      id: 1,
      name: "ຄ່າຄອມມິດຊັ່ນ ສຳລັບຮ້ານ",
      icon: faPodcast,
      rounter: "/commision-form",
    },
    {
      id: 2,
      name: "ຄ່າຄອມມິດຊັ່ນສຳລັບ ແອັຟຟິລີເອດ Affiliate",
      icon: faAddressBook,
      rounter: "/commission-affiliate",
    },
  ];

  const [getShopData, { data: shopData, loading: loadingShop }] = useLazyQuery(
    SHOP,
    { fetchPolicy: "cache-and-network" }
  );

  const [updateCommisionShopService, { loading: loadingUpdate }] = useMutation(
    UPDATE_SHOP_SETTING_SERVICE
  );

  console.log("shopData----->", shopData);

  const [updateShop, { loading: updateShopLoading }] = useMutation(UPDATE_SHOP);

  useEffect(() => {
    fetchShopInfo();
  }, [shopId]);

  const fetchShopInfo = () => {
    getShopData({
      variables: {
        where: {
          id: shopId,
        },
      },
    });
  };

  useEffect(() => {
    if (shopData?.shop) {
      setShopDetail(shopData?.shop);
    }
  }, [shopData]);

  const _handleSwitchService = async () => {
    try {
      if (updateShopLoading) return;
      setShopDetail({
        ...shopDetail,
        commissionService: shopDetail?.commissionService ? false : true,
      });
      await updateShop({
        variables: {
          data: {
            commissionService: shopDetail?.commissionService ? false : true,
          },
          where: {
            id: shopId,
          },
        },
      });
    } catch (error) {
      addToast("ເກີດຂໍ້ຜິດພາດ!", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  const _handleSwitchAffiliate = async () => {
    try {
      if (updateShopLoading) return;
      setShopDetail({
        ...shopDetail,
        commissionAffiliate: shopDetail?.commissionAffiliate ? false : true,
      });
      await updateShop({
        variables: {
          data: {
            commissionAffiliate: shopDetail?.commissionAffiliate ? false : true,
          },
          where: {
            id: shopId,
          },
        },
      });
    } catch (error) {
      addToast("ເກີດຂໍ້ຜິດພາດ!", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  // ສະຫລັບການເປີດ - ປີດ ການນຳໃຊ້ affiliate ສຳລັບຮ້ານ
  const handleCancelInflu = async () => {
    try {
      // if (updateShopLoading) return;

      const res = await updateShop({
        variables: {
          data: {
            isUseInflu: false,
          },
          where: {
            id: shopId,
          },
        },
      });
      if (res) {
        fetchShopInfo();
      }
    } catch (error) {
      addToast("ເກີດຂໍ້ຜິດພາດ!", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };
  const handleOnAirInflu = async () => {
    try {
      // if (updateShopLoading) return;

      const res = await updateShop({
        variables: {
          data: {
            isUseInflu: true,
          },
          where: {
            id: shopId,
          },
        },
      });
      if (res) {
        fetchShopInfo();
      }
    } catch (error) {
      addToast("ເກີດຂໍ້ຜິດພາດ!", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  return (
    <div>
      <div style={{ background: "#eee", height: "auto" }}>
        <div
          style={{
            margin: "60px 20px",
            display: "flex",
            flexDirection: "column",
          }}>
          <h5 style={{ fontWeight: "bold", marginTop: 10 }}>
            ຕັ້ງຄ່າສຳລັບ ເຊວເພຈ
          </h5>
          <div>
            ກຳນົດຄ່າຄອມມິດຊັ່ນ, <div></div>
          </div>
          <div className="containerSettings">
            <div
              className="cardSetting" style={{width: width>700? '25%':'100%'}}
              onClick={() => {
                history.push("commision-form");
              }}>
              <div
                style={{
                  padding: 10,
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "20px",
                  }}>
                  <FontAwesomeIcon style={{ fontSize: 30 }} icon={faPodcast} />
                  <h2>{shopData?.shop?.commision ?? 0}%</h2>
                </div>
                <div style={{ fontSize: 22 }}>ຄ່າຄອມມິດຊັ່ນ ສຳລັບຮ້ານ</div>
              </div>
            </div>

            <div
              className="cardSetting" style={{width: width>700? '25%':'100%'}}
              // onClick={() => {
              //   history.push("commission-affiliate");
              // }}
            >
              <div
                style={{
                  padding: 10,
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "20px",
                  }}>
                  {updateShopLoading ? (
                    <Spinner />
                  ) : (
                    <FontAwesomeIcon
                      style={{ fontSize: 30 }}
                      icon={faAddressBook}
                    />
                  )}
                  <div>
                    <div
                      style={{
                        display: "flex",
                        gap: 5,
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                      }}>
                      <Form.Check
                        type="switch"
                        id="custom-switch-1"
                        checked={shopDetail?.commissionService}
                        onChange={_handleSwitchService}
                        label={`ຄ່າບໍລິການແພັດຟອມ 3% ເປີເຊັນ`}
                      />

                      <br />
                      <Form.Check
                        type="switch"
                        id="custom-switch-2"
                        // label="Influencer"
                        label={`ອາຟຣິລີເອດ ${shopData?.shop?.commision}% ເປີເຊັນ`}
                        checked={shopDetail?.commissionAffiliate}
                        onChange={_handleSwitchAffiliate}
                      />
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: 22 }}>ກຳນົດສະແດງລາຄາສິນຄ້າ</div>
              </div>
            </div>

            <div
              className="cardSetting" style={{width: width>700? '25%':'100%'}}
              // onClick={() => {
              //   history.push("commission-affiliate");
              // }}
            >
              <div
                style={{
                  padding: 10,
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "20px",
                  }}>
                  {updateShopLoading ? (
                    <Spinner />
                  ) : (
                    <FontAwesomeIcon
                      style={{ fontSize: 30 }}
                      icon={faAddressBook}
                    />
                  )}
                  <div>
                    <div
                      style={{
                        display: "flex",
                        gap: 5,
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                      }}>
                      {shopData?.shop?.isUseInflu === false ? (
                        <Form.Check
                          type="switch"
                          id="custom-switch-2"
                          label={"ປີດນຳໃຊ້"}
                          checked={false}
                          onClick={handleOnAirInflu}
                        />
                      ) : (
                        <Form.Check
                          type="switch"
                          id="custom-switch-2"
                          checked={true}
                          label={"ເປີດນຳໃຊ້ແລ້ວ"}
                          onClick={handleCancelInflu}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: 22 }}>
                  ໂຟບີ ແອັຟຟິລີເອດ (4B Afiliate)
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SettingSPage;
